import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
export default class Repairs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_update: false,
      modal_detail: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_status: "",

      data: [],
      count: 10,

      stock_activity_list: [],
      transaction_list: [],
      transaction_spare_part: [],
      transaction_main: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET("admin/repairs/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        // status_code: "เสร็จสิ้น,อัพเดทต้นทุนเสร็จสิ้น",
        type: "ซ่อมภายใน,ประกอบ",
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }

    this.setState({
      data,
      count,
    });
    loading(false);
  };

  GetByID = async (id) => {
    loading(true);
    let result = await GET("admin/repairs/list", {
      uid: id,
    });
    if (result?.status) {
      this.setState({
        ...result.data,
        date: format_date(result.data.date, "yyyy-mm-dd", "en"),
      });
    }

    loading(false);
  };

  Update = async (_status) => {
    const {
      uid,
      stock_activity_list,
      transaction_list,
      transaction_spare_part,
      transaction_main,
    } = this.state;

    let is_none_price = false;
    let is_none_cause = false;
    stock_activity_list.forEach((e) => {
      e.transaction_list.forEach((tx) => {
        if (Number(tx.unit_price) === 0) {
          is_none_price = true;
        }
        if (!tx.cost_type) {
          is_none_cause = true;
        }
      });
    });
    transaction_list.forEach((tx) => {
      if (Number(tx.unit_price) === 0) {
        is_none_price = true;
      }
      if (!tx.cost_type) {
        is_none_cause = true;
      }
    });
    transaction_spare_part.forEach((tx) => {
      if (Number(tx.unit_price) === 0) {
        is_none_price = true;
      }
      if (!tx.cost_type) {
        is_none_cause = true;
      }
    });
    transaction_main.forEach((tx) => {
      if (Number(tx.unit_price) === 0) {
        is_none_price = true;
      }
      if (!tx.cost_type) {
        is_none_cause = true;
      }
    });
    if (is_none_price) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
      return;
    }
    if (is_none_cause) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทต้นทุน");
      return;
    }

    let re_sale = await Promise.all(
      stock_activity_list.map((e) =>
        this.UpdatePrice(e.uid, e.transaction_list)
      )
    );
    if (!re_sale.every((e) => e)) {
      loading(false);
      return;
    }
    // return
    loading(true);
    let body = {
      status: "เสร็จสิ้น",
      status_cost: true,
      transaction_list,
      transaction_spare_part: transaction_spare_part.map(e=>({...e,product_id: e.product?.uid || null, warehouse_id: e.warehouse?.uid || null})),
      transaction_main: transaction_main.map(e=>({...e,product_id: e.product?.uid || null, warehouse_id: e.warehouse?.uid || null})),
    };

    let result = await PUT("admin/repairs/update/" + uid, body);
    if (result?.status) {
      alert(_status === "เสร็จสิ้น" ? "/repair/repairs" : "#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  UpdatePrice = async (uid, transaction_list, status = "เสร็จสิ้น") => {
    const { receipt_type } = this.state;
    let amount = 0;

    for (let item of transaction_list) {
      if (!item.unit_price || Number(item.unit_price) <= 0) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
        return;
      }
      amount += Number(item.qty) * (Number(item.unit_price) || 0);
    }

    loading(true);
    let body = {
      amount: Number(amount),
      is_vat: receipt_type === "ต้องการ Vat",
      amount_net: Number(amount),
      status: status,
      count_order: transaction_list.length,
      count_item: total(transaction_list, "qty"),
      receipt_type: receipt_type || "ไม่ต้องการ Vat",
      withdrawal_type: "เบิกแจ้งซ่อม",

      transaction_list: transaction_list.map((e) => ({
        ...e,
        product_id: e.product?.uid,
        cost_price: Number(e.cost_price),
        unit_price: Number(e.unit_price),
      })),
    };

    let result = await PUT("admin/stock-activities/update/" + uid, body);
    return result.status;
  };
  render() {
    const {
      modal_update,
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      data,
      count,
      stock_activity_list,
      transaction_list,
      transaction_spare_part,
      transaction_main,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">อัพเดทต้นทุน</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">เลขที่ใบแจ้งซ่อม</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">ช่างผู้รับผิดชอบ</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.document_no}</td>
                      <td className="text-nowrap">
                        {item.customer?.full_name || ""}
                      </td>
                      <td className="text-nowrap">
                        {item.user?.full_name || ""}
                      </td>
                      <td className="text-nowrap">
                        {item.status === "ยกเลิก" ? "ยกเลิก" : (item.status_cost ? "เสร็จสิ้น" : "รออัพเดท")}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          {!item.status_cost && item.status !== "ยกเลิก" && (
                            <BtnIcon
                              type="update"
                              onClick={async () => {
                                await this.GetByID(item.uid);
                                this.setState({ modal_update: true });
                              }}
                            />
                          )}
                          {(item.status_cost || item.status === "ยกเลิก") && (
                            <BtnIcon
                              type="view"
                              onClick={async () => {
                                await this.GetByID(item.uid);
                                this.setState({ modal_detail: true });
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_update || modal_detail}
          onHide={() =>
            this.setState({ modal_update: false, modal_detail: false })
          }
          fullscreen={true}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_update ? "อัพเดทต้นทุน" : "รายละเอียดอัพเดทต้นทุน"}
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">ประเภทต้นทุน</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-end">ราคาต้นทุน</td>
                    <td className="text-nowrap text-end">ราคาต่อหน่วย</td>
                    <td className="text-nowrap text-end">ราคารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {stock_activity_list.length !== 0 && (
                    <tr>
                      <td
                        className="text-nowrap align-middle fw-bold bg-primary-light"
                        colSpan={8}
                      >
                        สินค้าเบิกซ่อม
                      </td>
                    </tr>
                  )}
                  {stock_activity_list?.map((item, index) => (
                    <>
                      {item.transaction_list.map((tx, tx_index) => (
                        <tr>
                          <td className="text-nowrap align-middle">
                            {tx.product_code}
                          </td>
                          <td className="text-nowrap align-middle">
                            {tx.product_name}
                          </td>
                          <td className="text-nowrap align-middle">
                            {tx.serial_number}
                          </td>
                          <td className="text-nowrap align-middle">
                            {modal_update ? (
                              <select
                                type="text"
                                className="form-select"
                                placeholder="0.00"
                                onChange={(e) => {
                                  stock_activity_list[index].transaction_list[
                                    tx_index
                                  ].cost_type = e.target.value;
                                  this.setState({ stock_activity_list });
                                }}
                                value={tx.cost_type}
                              >
                                <option value="">-- ประเภทต้นทุน --</option>
                                <option value="สินค้า">สินค้า</option>
                                <option value="ค่าแรง">ค่าแรง</option>
                              </select>
                            ) : (
                              tx.cost_type
                            )}
                          </td>
                          <td className="text-nowrap align-middle text-center">
                            {modal_update ? (
                              <input
                                type="text"
                                className="form-control text-end"
                                placeholder="0.00"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  stock_activity_list[index].transaction_list[
                                    tx_index
                                  ].qty = e.target.value;
                                if(transaction_main.length !== 0){
                                    let _total = 0;
                                    for(let it of stock_activity_list){
                                      for(let t of it.transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    }
                                    for(let t of transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    for(let t of transaction_spare_part){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    transaction_main[0].cost_price = _total;
                                  }
                                  this.setState({ stock_activity_list, transaction_main });
                                }}
                                value={tx.qty}
                              />
                            ) : (
                              tx.qty
                            )}
                          </td>
                          <td className="text-nowrap align-middl text-end">
                            {modal_update ? (
                              <input
                                type="text"
                                className="form-control text-end"
                                placeholder="0.00"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  stock_activity_list[index].transaction_list[
                                    tx_index
                                  ].cost_price = e.target.value;
                                  this.setState({ stock_activity_list });
                                }}
                                value={tx.cost_price}
                              />
                            ) : (
                              toFixed(tx.cost_price)
                            )}
                          </td>
                          <td className="text-nowrap align-middl text-end">
                            {modal_update ? (
                              <input
                                type="text"
                                className="form-control text-end"
                                placeholder="0.00"
                                onChange={(e) => {
                                  if (!float(e.target.value)) return;
                                  stock_activity_list[index].transaction_list[
                                    tx_index
                                  ].unit_price = e.target.value;
                                  if(transaction_main.length !== 0){
                                    let _total = 0;
                                    for(let it of stock_activity_list){
                                      for(let t of it.transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    }
                                    for(let t of transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    for(let t of transaction_spare_part){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    transaction_main[0].cost_price = _total;
                                  }
                                  this.setState({ stock_activity_list, transaction_main });
                                }}
                                value={tx.unit_price}
                              />
                            ) : (
                              toFixed(tx.unit_price)
                            )}
                          </td>
                          <td className="text-nowrap align-middle text-end">
                            {toFixed(Number(tx.sale_price))}
                          </td>
                        </tr>
                      ))}
                    </>
                  ))}
                   {transaction_list.length !== 0 && (
                    <tr>
                      <td
                        className="text-nowrap align-middle fw-bold bg-primary-light"
                        colSpan={8}
                      >
                        สินค้าอื่นๆ
                      </td>
                    </tr>
                  )}
                  {transaction_list.map((tx, tx_index) => (
                    <tr>
                      <td className="text-nowrap align-middle">
                        {tx.product_code}
                      </td>
                      <td className="text-nowrap align-middle">
                        {tx.product_name}
                      </td>
                      <td className="text-nowrap align-middle">
                        {tx.serial_number}
                      </td>
                      <td className="text-nowrap align-middle">
                        {modal_update ? (
                          <select
                            type="text"
                            className="form-select"
                            placeholder="0.00"
                            onChange={(e) => {
                              transaction_list[tx_index].cost_type =
                                e.target.value;
                              this.setState({ transaction_list });
                            }}
                            value={tx.cost_type}
                          >
                            <option value="">-- ประเภทต้นทุน --</option>
                            <option value="สินค้า">สินค้า</option>
                            <option value="ค่าแรง">ค่าแรง</option>
                          </select>
                        ) : (
                          tx.cost_type
                        )}
                      </td>
                      <td className="text-nowrap align-middle text-center">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[tx_index].qty = e.target.value;
                                if(transaction_main.length !== 0){
                                    let _total = 0;
                                    for(let it of stock_activity_list){
                                      for(let t of it.transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    }
                                    for(let t of transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    for(let t of transaction_spare_part){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    transaction_main[0].cost_price = _total;
                                  }
                              this.setState({ transaction_list, transaction_main });
                            }}
                            value={tx.qty}
                          />
                        ) : (
                          tx.qty
                        )}
                      </td>
                      <td className="text-nowrap align-middl text-end">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[tx_index].cost_price =
                                e.target.value;
                              this.setState({ transaction_list });
                            }}
                            value={tx.cost_price}
                          />
                        ) : (
                          toFixed(tx.cost_price)
                        )}
                      </td>
                      <td className="text-nowrap align-middl text-end">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[tx_index].unit_price =
                                e.target.value;if(transaction_main.length !== 0){
                                    let _total = 0;
                                    for(let it of stock_activity_list){
                                      for(let t of it.transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    }
                                    for(let t of transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    for(let t of transaction_spare_part){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    transaction_main[0].cost_price = _total;
                                  }
                              this.setState({ transaction_list, transaction_main });
                            }}
                            value={tx.unit_price}
                          />
                        ) : (
                          toFixed(tx.unit_price)
                        )}
                      </td>
                      <td className="text-nowrap align-middle text-end">
                        {toFixed(Number(tx.sale_price))}
                      </td>
                    </tr>
                  ))}
                  {transaction_spare_part.length !== 0 && (
                    <tr>
                      <td
                        className="text-nowrap align-middle fw-bold bg-primary-light"
                        colSpan={8}
                      >
                        สินค้าเลือกประกอบ
                      </td>
                    </tr>
                  )}
                  {transaction_spare_part.map((tx, tx_index) => (
                    <tr>
                      <td className="text-nowrap align-middle">
                        {tx.product_code}
                      </td>
                      <td className="text-nowrap align-middle">
                        {tx.product_name}
                      </td>
                      <td className="text-nowrap align-middle">
                        {tx.serial_number}
                      </td>
                      <td className="text-nowrap align-middle">
                        {modal_update ? (
                          <select
                            type="text"
                            className="form-select"
                            placeholder="0.00"
                            onChange={(e) => {
                              transaction_spare_part[tx_index].cost_type =
                                e.target.value;
                              this.setState({ transaction_spare_part });
                            }}
                            value={tx.cost_type}
                          >
                            <option value="">-- ประเภทต้นทุน --</option>
                            <option value="สินค้า">สินค้า</option>
                            <option value="ค่าแรง">ค่าแรง</option>
                          </select>
                        ) : (
                          tx.cost_type
                        )}
                      </td>
                      <td className="text-nowrap align-middle text-center">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_spare_part[tx_index].qty =
                                e.target.value;
                                if(transaction_main.length !== 0){
                                    let _total = 0;
                                    for(let it of stock_activity_list){
                                      for(let t of it.transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    }
                                    for(let t of transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    for(let t of transaction_spare_part){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    transaction_main[0].cost_price = _total;
                                  }
                              this.setState({ transaction_spare_part, transaction_main });
                            }}
                            value={tx.qty}
                          />
                        ) : (
                          tx.qty
                        )}
                      </td>
                      <td className="text-nowrap align-middl text-end">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_spare_part[tx_index].cost_price =
                                e.target.value;
                              this.setState({ transaction_spare_part });
                            }}
                            value={tx.cost_price}
                          />
                        ) : (
                          toFixed(tx.cost_price)
                        )}
                      </td>
                      <td className="text-nowrap align-middl text-end">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_spare_part[tx_index].unit_price =
                                e.target.value;
                                if(transaction_main.length !== 0){
                                    let _total = 0;
                                    for(let it of stock_activity_list){
                                      for(let t of it.transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    }
                                    for(let t of transaction_list){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    for(let t of transaction_spare_part){
                                        _total += Number(t.unit_price) * Number(t.qty)
                                      }
                                    transaction_main[0].cost_price = _total;
                                  }
                              this.setState({ transaction_spare_part, transaction_main });
                            }}
                            value={tx.unit_price}
                          />
                        ) : (
                          toFixed(tx.unit_price)
                        )}
                      </td>
                      <td className="text-nowrap align-middle text-end">
                        {toFixed(Number(tx.sale_price))}
                      </td>
                    </tr>
                  ))}
                  {transaction_main.length !== 0 && (
                    <tr>
                      <td
                        className="text-nowrap align-middle fw-bold bg-primary-light"
                        colSpan={8}
                      >
                        สินค้านำเข้าคลัง
                      </td>
                    </tr>
                  )}
                  {transaction_main.map((tx, tx_index) => (
                    <tr>
                      <td className="text-nowrap align-middle">
                        {tx.product_code}
                      </td>
                      <td className="text-nowrap align-middle">
                        {tx.product_name}
                      </td>
                      <td className="text-nowrap align-middle">
                        {tx.serial_number}
                      </td>
                      <td className="text-nowrap align-middle">
                        {modal_update ? (
                          <select
                            type="text"
                            className="form-select"
                            placeholder="0.00"
                            onChange={(e) => {
                              transaction_main[tx_index].cost_type =
                                e.target.value;
                              this.setState({ transaction_main });
                            }}
                            value={tx.cost_type}
                          >
                            <option value="">-- ประเภทต้นทุน --</option>
                            <option value="สินค้า">สินค้า</option>
                            <option value="ค่าแรง">ค่าแรง</option>
                          </select>
                        ) : (
                          tx.cost_type
                        )}
                      </td>
                      <td className="text-nowrap align-middle text-center">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_main[tx_index].qty = e.target.value;
                              this.setState({ transaction_main });
                            }}
                            value={tx.qty}
                          />
                        ) : (
                          tx.qty
                        )}
                      </td>
                      <td className="text-nowrap align-middl text-end">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_main[tx_index].cost_price =
                                e.target.value;
                              this.setState({ transaction_main });
                            }}
                            value={tx.cost_price}
                          />
                        ) : (
                          toFixed(tx.cost_price)
                        )}
                      </td>
                      <td className="text-nowrap align-middl text-end">
                        {modal_update ? (
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_main[tx_index].unit_price =
                                e.target.value;
                              this.setState({ transaction_main });
                            }}
                            value={tx.unit_price}
                          />
                        ) : (
                          toFixed(tx.unit_price)
                        )}
                      </td>
                      <td className="text-nowrap align-middle text-end">
                        {toFixed(Number(tx.sale_price))}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="fw-bold">
                  <tr>
                    <td className="text-nowrap align-middle" colSpan={4}>
                      รวมทั้งสิ้น
                    </td>
                    <td className="text-nowrap align-middle text-end">
                      {(() => {
                        let _total = 0;
                        for (let item of stock_activity_list) {
                          for (let tx of item.transaction_list) {
                            _total += Number(tx.qty);
                          }
                        }
                        for (let tx of transaction_list) {
                          _total += Number(tx.qty);
                        }
                        for (let tx of transaction_spare_part) {
                          _total += Number(tx.qty);
                        }
                        for (let tx of transaction_main) {
                          _total += Number(tx.qty);
                        }
                        return _total;
                      })()}
                    </td>
                    <td className="text-nowrap align-middl text-end">
                      {(() => {
                        let _total = 0;
                        for (let item of stock_activity_list) {
                          for (let tx of item.transaction_list) {
                            _total += Number(tx.cost_price);
                          }
                        }
                        for (let tx of transaction_list) {
                          _total += Number(tx.cost_price);
                        }
                        for (let tx of transaction_spare_part) {
                          _total += Number(tx.cost_price);
                        }
                        for (let tx of transaction_main) {
                          _total += Number(tx.cost_price);
                        }
                        return toFixed(_total);
                      })()}
                    </td>
                    <td className="text-nowrap align-middl text-end">
                      {(() => {
                        let _total = 0;
                        for (let item of stock_activity_list) {
                          for (let tx of item.transaction_list) {
                            _total += Number(tx.unit_price);
                          }
                        }
                        for (let tx of transaction_list) {
                          _total += Number(tx.unit_price);
                        }
                        for (let tx of transaction_spare_part) {
                          _total += Number(tx.unit_price);
                        }
                        for (let tx of transaction_main) {
                          _total += Number(tx.unit_price);
                        }
                        return toFixed(_total);
                      })()}
                    </td>
                    <td className="text-nowrap align-middle text-end">
                      {(() => {
                        let _total = 0;
                        for (let item of stock_activity_list) {
                          for (let tx of item.transaction_list) {
                            _total += Number(tx.sale_price);
                          }
                        }
                        for (let tx of transaction_list) {
                          _total += Number(tx.sale_price);
                        }
                        for (let tx of transaction_spare_part) {
                          _total += Number(tx.sale_price);
                        }
                        for (let tx of transaction_main) {
                          _total += Number(tx.sale_price);
                        }
                        return toFixed(_total);
                      })()}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </Modal.Body>
          {modal_update && (
            <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
              <div className="d-flex">
                <button
                  className="btn btn-dark px-5 me-1"
                  onClick={() => {
                    this.Update();
                  }}
                >
                  บันทึก
                </button>
                <button
                  className="btn btn-outline-dark px-5 ms-1"
                  onClick={() => {
                    this.setState({ modal_update: false });
                  }}
                >
                  ยกเลิก
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </div>
    );
  }
}
